import Swiper, { Navigation } from "swiper";
import CaptionSwitcher from "./_caption-switcher";

class Highlights {
    constructor() {
        this.$highlights = document.querySelector("[data-highlights]");
        this.$swiperContainer = document.querySelector("[data-highlights-swiper]");
        if (!this.$swiperContainer || !this.$highlights) {
            return;
        }
        this.setup();
    }


    setupCaptions() {
        const $captionTargets = this.$highlights.querySelectorAll(
            "[data-caption-switcher-target]"
        );
        $captionTargets.forEach(($target) => {
            $target.addEventListener("caption-switcher-target-active", () => {
                $target.closest("[data-list-transition]").setTransitionIn();
            });

            $target.addEventListener("caption-switcher-target-inactive", () => {
                $target.closest("[data-list-transition]").setTransitionOut();
            });
        });
        this.captionSwitcher = new CaptionSwitcher();
    }
    setupSwiper() {
        this.swiper = new Swiper(this.$swiperContainer, {
            slidesPerGroup: 1,
            slidesPerView: 1.25,
            spaceBetween: 15,
            initialSlide: 0,
            on: {
                realIndexChange: () => {
                    const event = new Event("real-index-change");
                    this.$swiperContainer.dispatchEvent(event);
                },
            },
            breakpoints: {
                834: {
                    slidesPerView: 2,
                },
                1920: {
                    slidesPerView: 3,
                },
            },
            autoHeight: true,
            centeredSlides: true,
            loop: true,
            modules: [Navigation],
            navigation: {
                nextEl: "[data-highlights-button-next]",
                prevEl: "[data-highlights-button-prev]",
            },
            runCallbacksOnInit: {}
        });
        
    }

    setup() {
        this.setupSwiper();
        this.setupCaptions();
    }
}

const HighlightsInstance = new Highlights();
export default HighlightsInstance;
